// One map, one active style. JSON fetches are cached; late responses cannot undo newer choices.
// The basemap is the vendored Protomaps style (tools/protomaps_style.mjs) in the theme's variant; tiles, glyphs and
// sprite are same-origin paths. REVISION matches the generated files: /web/vendor/* is cached as immutable.
const REVISION = 2;
export const styleURL = theme => `/web/vendor/protomaps/protomaps-${theme === 'dark' ? 'dark' : 'light'}.json?v=${REVISION}`;
// MapLibre parses sprite URLs and resolves tiles in workers: both need absolute URLs.
export const absoluteURL = (url, base = globalThis.location?.href) => typeof url === 'string' && url.startsWith('/') && base
  ? new URL(url, base).href.replace(/%7B/g, '{').replace(/%7D/g, '}') : url;
const absoluteSources = (sources = {}, base) => Object.fromEntries(Object.entries(sources).map(([id, s]) =>
  [id, {...s, ...(s.url ? {url: absoluteURL(s.url, base)} : {}), ...(s.tiles ? {tiles: s.tiles.map(url => absoluteURL(url, base))} : {})}]));
// Every basemap style the app shows: globe projection, absolute asset URLs.
export const appStyle = (style, base = globalThis.location?.href) => ({...style, projection: {type: 'globe'},
  sources: absoluteSources(style.sources, base),
  ...Object.fromEntries(['glyphs', 'sprite'].filter(k => style[k] !== undefined).map(k => [k, absoluteURL(style[k], base)]))});
// TileJSON (/tiles/world.json, /tiles/region.json) names its tiles by path; the map's transformRequest uses this.
export const absoluteRequest = url => ({url: absoluteURL(url)});
export function styleSwitcher(map, {fetchJSON, requested = () => {}, beforeApply = () => {}, applied = () => {}, failed = () => {}}) {
  const cache = new Map();
  let request = 0;
  return async (url, {reload = false} = {}) => {
    const token = ++request; requested();
    try {
      if (!cache.has(url)) cache.set(url, Promise.resolve().then(() => fetchJSON(url)).catch(error => { cache.delete(url); throw error; }));
      const style = await cache.get(url);
      if (token !== request) return false;
      beforeApply();
      if (reload) map.setStyle(appStyle(structuredClone(style)), {diff:false});
      else map.setStyle(appStyle(structuredClone(style)));
      applied();
      return true;
    } catch (error) {
      if (token === request) failed(error);
      return false;
    }
  };
}
